/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiSimpleTenantFromJSON, ApiSimpleTenantToJSON, } from './ApiSimpleTenant';
export function ApiSimpleTenantResponseFromJSON(json) {
    return ApiSimpleTenantResponseFromJSONTyped(json, false);
}
export function ApiSimpleTenantResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'tenants': !exists(json, 'tenants') ? undefined : (json['tenants'].map(ApiSimpleTenantFromJSON)),
    };
}
export function ApiSimpleTenantResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'tenants': value.tenants === undefined ? undefined : (value.tenants.map(ApiSimpleTenantToJSON)),
    };
}
